<template>
  <a href="javascript:;" class="a-upload">
    <input type="file" id="file" @change="onChange"/>
    <i class="fa fa-plus-square fa-lg"></i>
    <translate>Upload</translate>
  </a>
</template>

<script>
//  import $ from 'jquery'
  export default{
    props: {
      // Support Multiple File?
      multiple: {
        type: Boolean,
        default: false
      },
      // Pass the files info when it's done
      done: {
        type: Function,
        default: () => {}
      },
      loading: {
        type: Function,
        default: () => {}
      }
    },
    methods: {
      onClick () {
        document.getElementById('file').click()
      },
      onChange (e) {
        let files = e.target.files
        // Process each file
        let allFiles = []
        for (let i = 0; i < files.length; i++) {
          let file = files[i]
          let reader = new FileReader()
          // Convert the file to base64 text
          reader.readAsDataURL(file)
          reader.onload = () => {
            // Make a fileInfo Object
            let fileInfo = {
              name: file.name,
              type: file.type,
              size: Math.round(file.size),
              base64: reader.result,
              file: file
            }
            allFiles.push(fileInfo)
            // If all files have been proceed
            if (allFiles.length === files.length) {
              if (this.multiple) this.done(allFiles)
              else this.done(allFiles[0])
            }
            e.target.value = ''
          }
          reader.onprogress = (e) => {
            if (e.lengthComputable) {
              let percentComplete = e.loaded / e.total
              this.loading(true)
              console.log('process', percentComplete)
            } else {
              console.log('total size is unknown')
            }
          }
        }
      }
    }
  }
</script>

<style lang='scss' rel="stylesheet/scss">
  @import "../../../assets/css/variable";

  .a-upload {
    padding: 0 10px;
    height: 20px;
    line-height: 20px;
    position: relative;
    cursor: pointer;
    border-radius: 4px;
    display: inline-block;
    *display: inline;
    *zoom: 1;
    &:hover {
      color: $mainColor;
      cursor: pointer
    }
  }

  .a-upload input {
    display: none;
    position: absolute;
    font-size: 23px;
    width: 80px;
    right: 0;
    top: 2px;
    opacity: 0;
    filter: alpha(opacity=0);
    &:hover {
      cursor: pointer
    }
  }

  .a-upload:hover {
    text-decoration: none
  }

</style>



// WEBPACK FOOTER //
// vue-file-base64.vue?359b5180